<template>

  <fragment>

    <LoginHeader>
      <div class="level-item">
        <router-link :to="{name: 'users_login'}">
          <img src="../../../images/close.svg" height="40px"/>
        </router-link>
      </div>
    </LoginHeader>


    <div class="sm-container">
      <h1 class="title is-3"> Password Reset</h1>

      <fragment v-if="!updated">
        <h4 class="title is-4"></h4>

        <div class="sep-32"></div>
        <form action="" id="reset-form">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">New password</label>
                <div class="control">
                  <input class="input" vrules="required|password" type="password" v-model="formData.password">
                </div>
                <div class="help is-danger vrule" rule="required">
                  This field is required.
                </div>
                <div class="help is-danger vrule" rule="password">
                  Password must be at least 8 characters.
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">New password confirmation</label>
                <div class="control">
                  <input class="input" vrules="required" type="password" v-model="formData.passwordCofirmation">
                </div>
                <div class="help is-danger vrule" rule="required">
                  This field is required.
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <button :disabled="loading" @click.prevent="resetPassword()"
                      :class="{'is-loading': loading, 'is-disabled': loading}"
                      class="button  btn-block-with-icon  is-fullwidth is-primary">
                Reset your password
              </button>
            </div>
          </div>
        </form>
      </fragment>
      <div v-if="updated">
        Your password updated successfully,
        <router-link :to="{name: 'users_login'}">please click here to login.</router-link>
      </div>
    </div>
  </fragment>


</template>

<script>
import {LoginAPI} from "../../../apis/LoginAPI";
import LoginHeader from "../../../shared/components/LoginHeader";
import {FormValidation} from "../../../shared/directives/formValidation";
import {getParameterByName} from "../../../shared/utils";

export default {
  props: {},
  components: {LoginHeader},
  data() {
    return {
      formData: {},
      updated: false,
      loading: false,
    }
  },
  methods: {
    async resetPassword() {
      this.loading = true;
      let formValidation = new FormValidation('#reset-form')
      if (!formValidation.runAllValidations()) {
        this.loading = false;
        return;
      }

      if (this.formData.password !== this.formData.passwordCofirmation) {
        this.$toasted.show("Passwords must be the same!", {
          theme: "bubble",
          position: "top-center",
          duration: 4000,
          className: 'falcon-toasted',
        });
        this.loading = false;
        return;
      }
      let token = getParameterByName('token');
      let resp = await LoginAPI.updatePassword(token, this.formData.password, this.formData.passwordCofirmation);
      if (resp.success === true) {
        this.updated = true;
        SFAnalytics.track('User Reset Password Confirmation', { })
      } else {
        this.updated = false;
        this.$toasted.show(resp.msg, {
          theme: "bubble",
          position: "top-center",
          duration: 4000,
          className: 'falcon-toasted',
        });
      }
      this.loading = false;

    },
  },

};
</script>

<style lang="scss">
</style>
